import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider } from './context/UserContext'
import { SnackbarProvider } from 'notistack'


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <UserProvider>
    <SnackbarProvider maxSnack={3} autoHideDuration={3000} anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
      <App />
    </SnackbarProvider>
  </UserProvider>
);

reportWebVitals();
